export const BRAND_MANAGERS_META_DESCRIPTION =
  "Perceptica gives brand managers media intelligence and media listening to track campaigns, sentiment and competitors across SEE. Book a demo.";
